export default (state = [], action) => {
	switch (action.type) {
		case "SET_HOLIDAYS":
			return [...action.holidays];
		default:
			return state;
	}
};
